// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"textblockgroup_wrapper__xLxyw"};